import GlobalHeader from './GlobalFooter.vue'
export default GlobalHeader
